// Import the enum directly (not via the @utils barrel) so this pure helper —
// and its unit test — stay free of the heavy toast/UI side of @utils.
import { Scope } from '../../../utils/constants'

export interface MapContactsFilter {
  onlyGhost?: boolean
  scope?: Scope
}

/**
 * Derives the `usePaginateContacts` params for the map from the selected
 * chips. The chips are plain filters:
 * - no chip          -> everyone who can be placed, contacts and ghost
 *   profiles together
 * - PRIVATE or PROFESSIONAL -> only that group, contacts and ghosts alike
 *   (PRIVATE wins over PROFESSIONAL)
 * - GHOST            -> only ghost profiles, still narrowed by PRIVATE /
 *   PROFESSIONAL when one of them is selected too
 *
 * `false` is normalised to `undefined` so the flag drops out of the query
 * string instead of being sent as `onlyGhost=false`.
 */
export function buildMapContactsFilter(scope?: Scope[]): MapContactsFilter {
  return {
    onlyGhost: scope?.includes(Scope.GHOST) || undefined,
    scope: scope?.includes(Scope.PRIVATE)
      ? Scope.PRIVATE
      : scope?.includes(Scope.PROFESSIONAL)
        ? Scope.PROFESSIONAL
        : undefined,
  }
}
